import {h, Fragment} from "preact"
import { useResponse, AutocompleteElement, Keywords } from "@nosto/preact"
import { formatCurrency, productImagePlaceholder } from "../helpers"
import SubmitButton from "./elements/SubmitButton"
import { useEffect } from "preact/hooks"

export default function Autocomplete() {
    const { products, keywords, categories } = useResponse();

    useEffect(() => {
        Nosto.migrateToShopifyMarket({
            productSectionElement: '.ns-autocomplete-products .nosto-product-info',
            productHandleAttribute: 'x-nosto-handle',
            priceElement: '.nosto-product-price .product-price__price.nosto-newprice',
            listPriceElement: '.nosto-product-price .product-price__price.nosto-oldprice',
        })
    }, [products.hits])

    if (!products?.hits?.length && !keywords?.hits?.length && !categories?.hits?.length) {
        return
    }

    // note: categories without URLs redirect to 404 page
    const finalCategories = categories?.hits?.filter(cat => !!cat.url).splice(0, 5) || [];

    return (
        <div
            class="ns-autocomplete ns-absolute ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box ns-mx-auto"
            data-nosto-element="autocomplete"
        >
            <div class="ns-w-100 ns-mt-sm-auto">
                <div class="ns-autoc-container ns-container">
                    {(keywords?.hits?.length > 0 || finalCategories.length > 0) && (
                        <div
                            class={`ns-autocomplete-keywords v-stack gap-6 sm:gap-8 ns-d-flex ns-flex-column ${
                                products?.hits?.length > 0 ? "ns-col-sm-20" : "ns-col-sm-12"
                            }`}
                        >
                            <div class="ns-auto-title">
                                SUGGESTIONS
                            </div>
                            <div class="ns-predictive-search__suggestions ns-d-flex">
                                <Keywords
                                    hits={keywords.hits}
                                    keywordComponent={Keyword}
                                    elementComponent={Element}
                                    keywordInCategoryComponent={KeywordInCategory}
                                /> 
                            </div>

                            {finalCategories?.length > 0 && (
                                <>
                                    <div class="ns-auto-title">
                                        COLLECTION SUGGESTIONS
                                    </div>
                                    <div class="ns-predictive-search__suggestions ns-d-flex">
                                        {finalCategories
                                        .map(item => (
                                            <AutocompleteElement
                                                key={item?.externalId}
                                                class="ns-clickable"
                                                hit={{ 
                                                    keyword: item?.name,
                                                    _redirect: item?.url, 
                                                    url: item?.url ?? null 
                                                }}
                                            >
                                                {item?.name}
                                            </AutocompleteElement>
                                        ))}
                                    </div>
                                </>
                            )}

                            {/* {!products?.hits?.length && <SubmitButton text="See all search results" />} */}
                        </div>
                    )}
                    {products?.hits?.length > 0 && (
                        <div class="ns-autocomplete-products ns-d-flex ns-flex-column ns-flex-grow-1">
                            {/* <div class="ns-color-black ns-py-2 ns-px-4 ns-font-medium ns-font-4">
                                Products
                            </div> */}
                            <div class="ns-predictive-search__products">
                                {products?.hits?.map(hit => {

                                    // const hasLowerPrice = hit?.skus?.length > 1 && hit?.skus?.some(sku => sku.price !== hit.skus[0].price);
                                    // let lowestPrice = null;
                                    // if (hasLowerPrice) {
                                    //     lowestPrice = Math.min(...hit.skus.map(sku => sku.price));
                                    // }
                                    return (
                                        <AutocompleteElement hit={hit} class="nosto-element col s6 m3 featured-collection__cell">
                                            <div
                                                data-url={hit.url}
                                                class="card card--alt nosto-product-info"
                                                data-nosto-element="product"
                                                x-nosto-handle={hit.url.substring(hit.url.lastIndexOf('/') + 1)}
                                            >
                                                {/* <a href="javascript:void(0)">
                                                    <img
                                                        class="ns-h-auto ns-object-contain"
                                                        src={hit.imageUrl ?? productImagePlaceholder}
                                                        alt={hit.name}
                                                        width="60"
                                                        height="40"
                                                    />
                                                </a> */}
                                                <div class="card__thumbnail">
                                                    <div class="card__image-wrapper ns-image-wrapper"> 
                                                        <img class="primary-image ls-is-cached lazyloaded" 
                                                            src={hit.imageUrl ?? productImagePlaceholder}
                                                            alt={hit.name}  /> 
                                                        <img class="secondary-image ls-is-cached lazyloaded" 
                                                            src={`${hit?.alternateImageUrls != null ? hit?.alternateImageUrls[hit?.alternateImageUrls?.length - 1] : hit.imageUrl}`}
                                                            alt={hit.name}  /> 
                                                    </div>
                                                </div>

                                                <div class="card__body">
                                                    <div class="h6 card__title ns-card-title x-nosto-title">
                                                        {hit.name}
                                                    </div>
                                                    <div>

                                                        <div class="h6 card__meta meta nosto-product-price">
                                                        {hit.listPrice && hit.listPrice > hit.price ? (
                                                                <>
                                                                    <span class="product-price__sale-label">Was  </span>
                                                                    <s class="product-price__price nosto-oldprice"></s>
                                                                        <span class="ns-product-price__sale product-price__price nosto-newprice"></span>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    {hit?.skus?.length > 1 && hasLowerPrice &&(
                                                                        <>From </> 
                                                                    )}
                                                                    <span class="product-price__price nosto-newprice"></span> 
                                                                </>
                                                            )} 
                                                        </div>


                                                    </div>
                                                </div>
                                            </div>
                                        </AutocompleteElement>
                                    )
                                })}
                            </div>
                            <SubmitButton text="VIEW ALL RESULTS" />
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}


function Keyword({ hit }) {
    return (
        <span class="link-reverse" style="cursor: pointer;" data-nosto-element="keyword">
            {hit?._highlight?.keyword ? (
                <span
                    dangerouslySetInnerHTML={{
                        __html: hit._highlight.keyword,
                    }}
                ></span>
            ) : (
                hit.keyword
            )}
        </span>
    )
}

function Element({ hit, keywordComponent, filter }) {
    return (
        <AutocompleteElement
            hit={hit}
            filter={filter}
            class=""
        >
            {keywordComponent}
        </AutocompleteElement>
    )
}

function KeywordInCategory({
    category,
    children,
}) {
    return (
        <>
            {category?.value ? (
                <>
                    {children}{" "}
                    <span class="ns-keyword-in-category">
                        in <span>{category.value}</span>
                    </span>
                </>
            ) : (
                children
            )}
        </>
    )
}
